document.addEventListener('click',event=>{
 const link=event.target.closest('.ak-product-gallery a,.ak-box-product-gallery a, .ak-box-gallery a');
 if(!link)return;
 event.preventDefault();
 const dialog=document.createElement('dialog');dialog.className='ak-image-zoom';
 const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label',document.documentElement.dataset.akZoomClose||'Close enlarged image');
 const image=document.createElement('img');image.src=link.href;image.alt=link.querySelector('img')?.alt||'';
 dialog.append(close,image);document.body.append(dialog);dialog.showModal();close.focus();
 close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.addEventListener('close',()=>{dialog.remove();link.focus();});
});
function placeLookByPrimaryImage(gallery,choice){
 const track=gallery.querySelector('.ak-product-gallery__track,.ak-box-product-gallery__track');
 if(matchMedia('(min-width:750px)').matches&&track?.querySelector('a'))track.querySelector('a').after(choice);
 else gallery.append(choice);
}
function positionPackagingControls(){
 document.querySelectorAll('.ak-look-choice[data-look-product]').forEach(choice=>{
  const gallery=document.querySelector(`[data-look-gallery="${CSS.escape(choice.dataset.lookProduct)}"]`);
  const form=choice.closest('form')||choice.querySelector('input')?.form;
  if(!gallery||!form)return;
  choice.querySelectorAll('input').forEach(input=>input.setAttribute('form',form.getAttribute('id')));
  placeLookByPrimaryImage(gallery,choice);
  gallery.querySelectorAll('.ak-product-gallery__progress,.ak-box-product-gallery__progress').forEach(counter=>counter.remove());
 });
 document.querySelectorAll('[data-packaging-accordion]').forEach(row=>{
  const section=row.closest('.shopify-section');
  const group=section?.querySelector('.accordion');
  if(group&&!group.contains(row))group.append(row);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',positionPackagingControls);
else positionPackagingControls();
document.addEventListener('shopify:section:load',positionPackagingControls);
matchMedia('(min-width:750px)').addEventListener('change',positionPackagingControls);
function showPackagingLook(input){
 if(!input?.matches('.ak-look-choice input[name="properties[Packaging look]"]')||!input.checked)return;
 const id=input.closest('[data-look-product]')?.dataset.lookProduct;
 if(!id)return;
 document.querySelectorAll(`[data-look-gallery="${CSS.escape(id)}"]`).forEach(gallery=>{
  const selected=[...gallery.querySelectorAll('[data-packaging-look]')].find(item=>item.dataset.packagingLook===input.value);
  if(!selected)return;
  const track=selected.parentElement;
  track.prepend(selected);
  const choice=gallery.querySelector('.ak-look-choice');
  if(choice)placeLookByPrimaryImage(gallery,choice);
  selected.querySelector('img')?.setAttribute('loading','eager');
  track.scrollTo({left:0,behavior:'instant'});
 });
}
document.addEventListener('change',event=>showPackagingLook(event.target));
document.addEventListener('click',event=>{
 const option=event.target.closest('.ak-look-choice__option');
 if(option)requestAnimationFrame(()=>showPackagingLook(option.querySelector('input')));
});


(() => {
  const initialize = () => {
    document.querySelectorAll('.ak-box-edit__chapter').forEach(chapter => {
      const rail=chapter.querySelector('.ak-box-edit__rail');
      const buttons=[...chapter.querySelectorAll('[data-box-direction]')];
      if(!rail || !buttons.length || rail.dataset.homeReady) return;
      rail.dataset.homeReady='true';
      const update=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.boxDirection)<0 ? rail.scrollLeft<2 : rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2);
      const move=direction=>rail.scrollBy({left:direction*((rail.firstElementChild?.getBoundingClientRect().width||300)+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.boxDirection))));
      rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      rail.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(rail);update();
    });
    const desktop=matchMedia('(min-width:750px)');
    document.querySelectorAll('.ak-footer .menu__details').forEach(details=>{
      if(details.dataset.homeReady)return;details.dataset.homeReady='true';
      const sync=()=>{details.open=desktop.matches;};
      desktop.addEventListener('change',sync);sync();
      details.addEventListener('toggle',()=>{if(desktop.matches&&!details.open)details.open=true;});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
